import { BaseExceptions } from '@/api/v4/base-fetch';

export function isUnauthorizedError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  // Check if it's an Axios error with response status
  if (
    'response' in error &&
    error.response &&
    typeof error.response === 'object'
  ) {
    const response = error.response as any;
    if (
      'status' in response &&
      response.status === BaseExceptions.UNAUTHORIZED
    ) {
      return true;
    }
  }

  // Check if it's an error with status property
  if (
    'status' in error &&
    (error as any).status === BaseExceptions.UNAUTHORIZED
  ) {
    return true;
  }

  // Check if it's an error with statusCode property
  if (
    'statusCode' in error &&
    (error as any).statusCode === BaseExceptions.UNAUTHORIZED
  ) {
    return true;
  }

  return false;
}
